import React from "react";
import {css} from "@emotion/react";

import {calculateRemSize, flex} from "@pg-design/helpers-css";
import {PauseIcon, PlayIcon, SoundOffIcon, SoundOnIcon} from "@pg-design/icons-module";

import {ReelDetailsControlButton} from "./ReelDetailsControlButton";

interface IProps {
    isMute: boolean;
    isPlaying: boolean;
    onMute: () => void;
    onUnmute: () => void;
    onPlay: () => void;
    onPause: () => void;
}

export const ReelDetailsVideoControls = (props: IProps) => {
    const handleMuteToggle = () => {
        if (props.isMute) {
            props.onUnmute();
        } else {
            props.onMute();
        }
    };

    const handlePlayToggle = () => {
        if (props.isPlaying) {
            props.onPause();
        } else {
            props.onPlay();
        }
    };

    return (
        <div css={wrapperStyle}>
            <ReelDetailsControlButton icon={props.isMute ? SoundOffIcon : SoundOnIcon} onClick={handleMuteToggle} iconSize="2" />
            <ReelDetailsControlButton icon={props.isPlaying ? PauseIcon : PlayIcon} onClick={handlePlayToggle} iconSize="2" />
        </div>
    );
};

const wrapperStyle = css`
    flex: 0 0 auto;
    ${flex("center", "space-between")};
    flex-direction: row;
    gap: ${calculateRemSize(2)};
`;
import React from "react";
import {css} from "@emotion/react";

import {calculateRemSize, flex} from "@pg-design/helpers-css";
import {PauseIcon, PlayIcon, SoundOffIcon, SoundOnIcon} from "@pg-design/icons-module";

import {ReelDetailsControlButton} from "./ReelDetailsControlButton";

interface IProps {
    isMute: boolean;
    isPlaying: boolean;
    onMute: () => void;
    onUnmute: () => void;
    onPlay: () => void;
    onPause: () => void;
}

export const ReelDetailsVideoControls = (props: IProps) => {
    const handleMuteToggle = () => {
        if (props.isMute) {
            props.onUnmute();
        } else {
            props.onMute();
        }
    };

    const handlePlayToggle = () => {
        if (props.isPlaying) {
            props.onPause();
        } else {
            props.onPlay();
        }
    };

    return (
        <div css={wrapperStyle}>
            <ReelDetailsControlButton icon={props.isMute ? SoundOffIcon : SoundOnIcon} onClick={handleMuteToggle} iconSize="2" />
            <ReelDetailsControlButton icon={props.isPlaying ? PauseIcon : PlayIcon} onClick={handlePlayToggle} iconSize="2" />
        </div>
    );
};

const wrapperStyle = css`
    flex: 0 0 auto;
    ${flex("center", "space-between")};
    flex-direction: row;
    gap: ${calculateRemSize(2)};
`;
